module.exports = __webpack_public_path__ + "media/coins_drop.3eada81a.wav";